import { UserManagement } from "@/components/UserManagement";
import { useNavigate } from "react-router-dom";

export const UsersPage = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate("/");
  return <UserManagement onBack={handleBack} />;
};
